
class SelectorVariants extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('form')
        this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange(event) {
        this.currentVariant = event.target.value
        this.updateMasterId()
        this.updateURL();
        this.renderProductInfo();
    }
    updateMasterId() {
        this.form.querySelector('.add-to-cart').setAttribute('data-variant-id', this.currentVariant)
    }
    updateURL(){
        const url = new URL(window.location);
        url.searchParams.set('variant', this.currentVariant);
        window.history.pushState(null, '', url.toString());
    }

    async renderProductInfo(){
        try{
            const response = await (await fetch(window.location.href + '&section_id=product-template')).text()
            const responseMarkup = new DOMParser().parseFromString(response, 'text/html')
            document.querySelector('[data-price-container]').innerHTML = responseMarkup.querySelector('[data-price-container]').innerHTML

            document.dispatchEvent(new CustomEvent('changed_variant', {
                    bubbles: true,
                    detail: {
                        section: this.form
                    }
                }));

        }catch (error) {
            console.error(error)
        }
    }

}
customElements.define('selector-variants', SelectorVariants);


class DiscountCoupon{
    constructor() {
        const [price, savingCoupon, savingBadge] = document.querySelector("#couponMarkupPatterns")?.content?.children
        this.markupPatterns = {
            price: price,
            savingCoupon: savingCoupon,
            savingBadge: savingBadge
        }


        this.discountCode = this.getCookie("discount_code")

        if(!this.discountCode){
            this.discountCode = localStorage.getItem("coupon")
        }

        if(!this.discountCode) return;

        localStorage.setItem("coupon", this.discountCode)

        this.getDiscount()
    }

    async getDiscount(){
        try{
            const { token } = await (await fetch('/cart.js')).json()
            if(!token.includes("key")) return


            const response = await (await fetch(`/apps/proxy?discountCode=${this.discountCode}&token=${token}`)).json()

            if(response.canUse !== "true") {
                localStorage.setItem("coupon", "")
                return
            }

            this.discountData = response
            this.initProductsHandler()

        }catch (error) {
        }
    }

    initProductsHandler(){
        const { items: {__typename: discountItemsType, products} } = this.discountData
        const productsSelector = discountItemsType === "AllDiscountItems" ? '[data-product-handle]'
            : products.nodes.map(({handle}) => `[data-product-handle=${handle}]`).join(',')

        this.productWrappers = document.querySelectorAll(productsSelector)

        if(!this.productWrappers) return

        this.updatePrices(this.productWrappers)

        this.productsHandler()
    }

    productsHandler(){
        document.addEventListener('changed_variant', ({detail: {section}}) =>{
            this.updatePrices(section.querySelectorAll(`[data-price-container]`))
        })
    }

    updatePrices(productsWrappers){
        const { value: {__typename: discountType} } = this.discountData
        const discountValue = discountType === "DiscountPercentage" ? this.discountData.value.percentage
            : this.discountData.value.amount.amount * 100

        productsWrappers.forEach(wrapper => {
            wrapper.querySelectorAll("[data-price]").forEach(priceWrapper => {
                const { priceFormat, price, comparePrice } = priceWrapper.dataset
                const [withCurrency, pattern, haveSaving, insetFormat, savingFormat] = priceFormat?.split("|")
                if(!price) return

                let updatePrice = discountType === "DiscountPercentage" ?
                    price * (1 - discountValue) :
                    price - discountValue

                if(savingFormat === "discount_amount"){
                    updatePrice = (comparePrice ? comparePrice : price) - updatePrice
                }

                const formatted_price = window.Shopify.formatMoney(updatePrice, withCurrency)
                if(insetFormat === "append"){
                    priceWrapper.innerHTML += this.buildPrice(formatted_price, pattern)
                } else if(insetFormat === "prepend"){
                    priceWrapper.innerHTML = this.buildPrice(formatted_price, pattern) + priceWrapper.innerHTML
                } else if(insetFormat === "insert"){
                    priceWrapper.innerHTML = this.buildPrice(formatted_price, pattern)
                }


                if(haveSaving){
                    const savingPercent = (((comparePrice ? comparePrice : price) - updatePrice) / (comparePrice ? comparePrice : price) * 100).toFixed(0)
                    priceWrapper.innerHTML += this.buildPrice(savingPercent, savingFormat)
                }
            })
        })
    }

    getCookie(name) {
        const match = document.cookie.match(new RegExp('(^|;)\\s*' + name + '=([^;]*)'))

        return match ? decodeURIComponent(match[2]) : null
    }

    buildPrice(money, type){
        switch (type){
            case "separated": {
                const [intPrice, fractionalPrice] = money.split(",")
                return this.markupPatterns.price.outerHTML.replace('{intPrice}', intPrice)
                    .replace('{fractionalPrice}', fractionalPrice)
                break
            }
            case "inline": {
                return money
                break
            }
            case "covered-inline": {
                return `<span>${money}</span>`
                break
            }
            case "coupon": {
                return this.markupPatterns.savingCoupon.outerHTML.replace('{percent}', money)
                break
            }
            case "badge": {
                return this.markupPatterns.savingBadge.outerHTML.replace('{percent}', money)
                break
            }
        }
    }

}
window.discountCoupon = new DiscountCoupon()